import React from "react";
import { createPortal } from "react-dom";
import { useToast } from "../../context/Toast/ToastContext";
import Toast from "./Toast";
import "./Toast.css";

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) {
    return null;
  }

  return createPortal(
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onRemove={removeToast} />
      ))}
    </div>,
    document.body
  );
};

export default ToastContainer;
